import type { AIStrengthLevel } from '@draughts/core';

/**
 * The AI strength ladder, as the dropdowns show it.
 *
 * Shared because the level is now picked in two places — the Sfida AI modal and the
 * "vs Computer" row of the Partita personalizzata — and two copies of a ladder drift
 * the first time a level is added or recoloured.
 *
 * The type is an alias of the CORE's own level, so this list and the engine's
 * calibration table (AI_STRENGTH_PROFILES) cannot say different things.
 */
export type AIDifficulty = AIStrengthLevel;

export const AI_DIFFICULTIES: readonly AIDifficulty[] = [
  'very-easy',
  'easy',
  'medium',
  'hard',
  'expert',
  'master',
] as const;

/** Suffix of the `game.modes.*` i18n key for each level. */
export const AI_DIFFICULTY_LABEL_KEY: Record<AIDifficulty, string> = {
  'very-easy': 'aiVeryEasy',
  easy: 'aiEasy',
  medium: 'aiMedium',
  hard: 'aiHard',
  expert: 'aiExpert',
  master: 'aiMaster',
};

/**
 * Accent dot per level — a green→red "traffic light" ladder so the strength is
 * legible at a glance in the dropdown (VariantSelect's native accent dot).
 */
export const AI_DIFFICULTY_DOT: Record<AIDifficulty, string> = {
  'very-easy': '#3D8B40',
  easy: '#7CB342',
  medium: '#C9A227',
  hard: '#E8873A',
  expert: '#E2542C',
  master: '#C0392B',
};
